module.exports = __webpack_public_path__ + "static/media/varal-tradicional-teto-manivela.2e93c332.jpg";